import { render } from "./regionStatus.vue?vue&type=template&id=db3f443a&scoped=true"
import script from "./regionStatus.vue?vue&type=script&lang=js"
export * from "./regionStatus.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3f443a"]])

export default __exports__